/**
 * Converts a presale end date string to milliseconds timestamp.
 * Handles both numeric timestamps (seconds or milliseconds) and date strings.
 *
 * @param presaleEndDate - The presale end date as a string (timestamp or date string)
 * @returns The timestamp in milliseconds, or null if invalid
 */
export function getPresaleEndMs(presaleEndDate?: string): number | null {
  if (!presaleEndDate) return null;

  const trimmed = presaleEndDate.trim();
  if (!trimmed) return null;

  const asNumber = Number(trimmed);
  if (Number.isFinite(asNumber) && asNumber > 0) {
    // Accept both seconds and milliseconds timestamps.
    return asNumber < 1e12 ? asNumber * 1000 : asNumber;
  }

  const parsed = Date.parse(trimmed);
  return Number.isFinite(parsed) ? parsed : null;
}
